import { regionApi, regionRequest } from './regionApi';

export const regionSocApi = regionApi.injectEndpoints({
  endpoints: (build) => ({
    /* ================================================== */
    /* Pre provision check                                */
    /* ================================================== */
    checkPreProvision: build.query<any, Record<string, any>>({
      query: ({ region, account_id }) =>
        regionRequest(region, 'instance/pre_provision_check', {
          method: 'POST',
          body: {
            account_id
          }
        })
    }),

    /* ================================================== */
    /* Provision request                                  */
    /* ================================================== */
    provisionRequest: build.mutation<any, Record<string, any>>({
      query: ({ region, account_id, additional_notes, parameters }) =>
        regionRequest(region, 'instance/provision_request', {
          method: 'POST',
          body: {
            account_id,
            additional_notes,
            notes: additional_notes,
            parameters
          }
        })
    })

    /* ================================================== */
  })
});

export const {
  useCheckPreProvisionQuery,
  useProvisionRequestMutation,
  useLazyCheckPreProvisionQuery
} = regionSocApi;
